import React from 'react';
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  SelectController,
  RangeController,
  ChoiceBoxController,
  SimpleColorPickerController,
} from '../../../controllers/Base';

import { getMapThemes } from '../../../utils/controllersUtils/themeColors';

const StyleControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
}) => (
  <>
    <ControllersGroup
      title="Estilos"
      id="styles"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.PalletsControl === 'custom' ? data?.index?.length : 0}
    >
      <RangeController
        label="Tamanho da borda"
        handle={handle}
        kWord="BorderWidthControl"
        configValue={config?.BorderWidthControl?.value}
        min={0}
        max={20}
        fullWidth
      />
      <SimpleColorPickerController
        label="Cor da borda"
        handle={handle}
        kWord="BordeColorMapsControl"
        configValue={config?.BordeColorMapsControl || '#000'}
        orientation="row"
        fullWidth
        disabled={!config?.BorderWidthControl?.value || config?.BorderWidthControl?.value.toString() === '0'}
      />
      <ChoiceBoxController
        label="Paleta de cores"
        handle={handle}
        kWord="PalletsControl"
        options={[
          { label: 'Padrão', value: 'default', id: 'default' },
          { label: 'Degradê', value: 'gradient', id: 'gradient' },
        ]}
        configValue={config?.PalletsControl}
        fullWidth
      />
      {config?.PalletsControl === 'default' && (
        <SelectController
          label="Tema"
          handle={handle}
          kWord="ColorTheme"
          options={getMapThemes()}
          configValue={config?.ColorTheme?.scheme || 'nivo'}
          fullWidth
        />
      )}
      {config?.PalletsControl === 'gradient' && (
        <>
          <SimpleColorPickerController
            label="Cor inicial"
            handle={handle}
            kWord="GradientFirstColor"
            configValue={config?.GradientPickerControl?.color1 || '#4711B2'}
            orientation="row"
          />
          <SimpleColorPickerController
            label="Cor final"
            handle={handle}
            kWord="GradientSecondColor"
            configValue={config?.GradientPickerControl?.color2 || '#FF9626'}
            orientation="row"
          />
        </>
      )}
    </ControllersGroup>
  </>
);

StyleControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
};

StyleControllers.defaultProps = {
  config: undefined,
  data: undefined,
  handle: () => {},
  extend: '',
  setExtend: () => {},
};

export default StyleControllers;
